
import Vue from 'vue';
import Heading from '@/components/Heading/index.vue';
import IconButton from '@/components/IconButton/index.vue';
import Tag from '@/components/Tag/index.vue';
import Button from '@/components/Button/index.vue';
import sendEmailService from '@/services/send-email';
import {
  Border, Header, Shadow, Wrapper, WrapperButtons,
} from './styles';

export default Vue.extend({
  name: 'Card',
  components: {
    Header,
    Heading,
    IconButton,
    Button,
    Tag,
    Wrapper,
    WrapperButtons,
  },
  props: {
    border: {
      type: String,
      default: 'small',
      validator(value: typeof Border[number]) {
        return Border.indexOf(value) !== -1;
      },
    },
    penaltyPageButton: {
      type: Boolean,
      default: false,
    },
    gradient: {
      type: Boolean,
      default: false,
    },
    headingTitle: String,
    paddingHorizontal: {
      type: Number,
      default: 0,
    },
    paddingVertical: {
      type: Number,
      default: 0,
    },
    shadow: {
      type: String,
      default: 'small',
      validator(value: typeof Shadow[number]) {
        return Shadow.indexOf(value) !== -1;
      },
    },
    showCloseButton: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    showButtons: {
      type: Boolean,
      default: false,
    },
    showButton: {
      type: Boolean,
      default: false,
    },
    penaltyCondition: {
      type: Boolean,
      default: false,
    },
    statusContestation: {
      type: String,
      default: '',
    },
    tagTitle: String,
    territory: String,
    url: String,
  },
  data() {
    return {
      sendingEmail: false,
    };
  },
  methods: {
    async sendEmailWithDocumentAttached() {
      this.sendingEmail = true;
      const { stEmail } = JSON.parse(sessionStorage.getItem('userLogged') || '{}');

      if (stEmail) {
        await sendEmailService({
          user: {
            email: stEmail,
            iamkey: 'B0A1C8F78547A12FE164672D5C3FCD5CFE0C216E8EC920B28739ECC78EA414F7',
          },
          title: `${this.territory} | ${this.headingTitle}`,
          attachmentUrl: this.url,
          body: {
            document: this.headingTitle,
            territory: this.territory,
          },
        }).then(() => {
          this.sendingEmail = false;
        });
      }
    },
  },
});
